module.exports = __webpack_public_path__ + "static/img/tradeRole.1b28596d.svg";